// A `moneyWithPeriod` question stores two answers: the raw value under the
// question id, and the chosen unit under `<id>Period`. This suffix is the single
// source of truth for that convention — derive the period key only via this
// helper so the value/default/build sides never drift.
export const PERIOD_KEY_SUFFIX = 'Period'

export const getPeriodAnswerKey = (questionId: string): string =>
  `${questionId}${PERIOD_KEY_SUFFIX}`
